import React, { useState, useRef, useEffect, useContext } from "react";

import { Box, Container, Grid, Typography, TextField, Stack, Button, CircularProgress, Paper, InputLabel, OutlinedInput, InputAdornment, FormControl, FormControlLabel, Switch, Chip, Divider } from '@mui/material';

import Autocomplete from '@mui/material/Autocomplete';

import CmsContext from '../../../store/cms-context';

import { getAccessJwtToken } from '../../../store/globalUtilities';

import { useNavigate } from 'react-router-dom';

import { Storage } from 'aws-amplify';
import { alpha, styled } from '@mui/material/styles';
import { grey , blue} from '@mui/material/colors';
import TimePicker from '@mui/lab/TimePicker';

import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import TimezoneSelect from "react-timezone-select";
import { cloneDeep } from "lodash";
import { ONE_DAY } from "../../../Utilities/Metrics";
import { has_marketing_write_access, has_product_management_write_access } from "../../../Utilities/HelperFunctions";


const CustomSwitch = styled(Switch)(({ theme }) => ({

  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      '& .MuiSwitch-thumb': {
        color:blue[800]
      }
    },
    '&:hover': {
      backgroundColor: alpha(blue[600], theme.palette.action.hoverOpacity),
    }
  },
  '& .MuiSwitch-thumb': {
    color:grey[200]
  },
  '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
    backgroundColor: blue[300],
        opacity: 1,
        border: 0,
  },
  
}));

function LastChanceConfigs(props) {


  const cmsContext = useContext(CmsContext);

  const isMountedRef = useRef(null);

  const [isLoading, setIsLoading] = useState(false);

  const [component_state, set_component_state] = React.useState({layout_type: 'list', collection_id : ''});

  const [all_stores, set_all_stores] = React.useState([]);

  const [active_stores, set_active_stores] = React.useState([]);

  const navigate = useNavigate();


  useEffect(() => {

    isMountedRef.current = true

    get_configurations_settings()

    return () => isMountedRef.current = false;

  }, [])






  function handle_active_stores_change(event, newValue){

    set_active_stores(newValue)

  }



  return(

    <>

   {isLoading ? <CircularProgress style={{position: 'absolute', top: '50%', left: '50%', MozTransform: 'translateX(-50%) translateY(-50%)', WebkitTransform: 'translateX(-50%) translateY(-50%)', transform: 'translateX(-50%) translateY(-50%)'}} /> :
   
   <Box
    component="main"
    sx={{
      flexGrow: 1,
      py: 8,
    }}
  >


    <Container maxWidth={false} style={{maxWidth:"1000px",overflow:'visible'}}>
  
    <Grid
        container
        spacing={2}
        style={{overflow:'visible'}}
      >

        <Grid
          item
          xs={12}
        >

        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="flex-end"
          spacing={2}
        >

          <Typography variant="h5">Configurations</Typography> 

          <div>

          <Button variant="contained" onClick = {() => {update_configurations("configurations")}}>Update Configurations</Button>

          </div>

        </Stack>

      </Grid>

      <Grid
          item
          xs={12}
        >

      <Paper elevation = {2} style={{marginTop:16, padding:20}}>
        
        <Grid
          container
          spacing={2}
          alignItems="center"
        >

          <Grid
            item
            xs={12}
          >

          <Autocomplete
            multiple
            id="active-stores"
            options={all_stores}
            getOptionLabel={(option) => option.name}
            value={active_stores}
            isOptionEqualToValue={(option, value) => option.store === value.store}
            onChange={(event, newValue) => {handle_active_stores_change(event, newValue)}}
            renderInput={(params) => (
              <TextField {...params} label="Active stores" placeholder="Active stores" />
            )}
          />     

        </Grid>



        {active_stores.map((account, index) => {

          return(

            <Grid key={index} item xs={12} >

            <Grid container spacing={2}>

            <Grid
            item 
            xs={12}
            >

              <Typography fontSize={14}><strong>{account.name}</strong></Typography>

            </Grid>
            
            <Grid
            item
            xs={6}
            >

              <TextField id="outlined-basic" label="Threshold" variant="outlined"
                fullWidth
                type="number"
                size="small"
                value={active_stores[index].threshold}
                onChange={(event) => {
                  
                  console.log('value was: ', event.target.value)

                  const temp_stores = [...active_stores];

                  if(event.target.value >= 0) {
                    temp_stores[index].threshold = event.target.value;
                  }
                  else{
                    temp_stores[index].threshold = 0;
                  }

                  set_active_stores(temp_stores);

                }}
              
                />

            </Grid>

               
            <Grid
              item
              xs={6}
            >

            <TextField id="outlined-basic" label="Inventory Tag" variant="outlined"
            fullWidth
            size="small"
            value={active_stores[index].inventory_tag ? active_stores[index].inventory_tag : ''}
            onChange={(event) => {
              
                console.log('value was: ', event.target.value)

                const temp_stores = [...active_stores];

                temp_stores[index].inventory_tag = event.target.value;

                set_active_stores(temp_stores);

            }}
            
            />

            </Grid>

            <Grid
            item
            xs={12}
            >

            <Stack
            sx={{
              alignItems: "center",
            }}
            spacing={3}
            direction="row"
            justifyContent="space-evenly"
            divider={<Divider orientation="vertical" flexItem />}
            >
              
              <FormControlLabel control={<Switch checked={account.archive_no_stock} onChange={(event) => {const temp_stores = [...active_stores]; temp_stores[index].archive_no_stock = event.target.checked; set_active_stores(temp_stores);}} />} sx={{
                '& .MuiFormControlLabel-label': {
                fontSize: '15px',
                },
                }}
                label="Archive No Stock"
                labelPlacement="start" />


              <FormControlLabel control={<Switch checked={account.unarchive_in_stock} onChange={(event) => {const temp_stores = [...active_stores]; temp_stores[index].unarchive_in_stock = event.target.checked; set_active_stores(temp_stores);}}/>} 
               sx={{
                '& .MuiFormControlLabel-label': {
                fontSize: '15px',
                },
                }}
                label="Un-Archive In Stock"
                labelPlacement="start" />

             { /*<FormControlLabel control={<Switch checked={account.add_tag} onChange={(event) => {const temp_stores = [...active_stores]; temp_stores[index].add_tag = event.target.checked; set_active_stores(temp_stores);}} />} sx={{
                '& .MuiFormControlLabel-label': { 
                fontSize: '15px',
                },
                }}
                label="Add Tag"
                labelPlacement="start" />

              */}

              

              {/* 
               <FormControlLabel control={<Switch checked={account.remove_tag} onChange={(event) => {const temp_stores = [...active_stores]; temp_stores[index].remove_tag = event.target.checked; set_active_stores(temp_stores);}}/>} 
                sx={{
                '& .MuiFormControlLabel-label': {
                fontSize: '15px',
                },
                }}
                label="Remove Tag"
                labelPlacement="start" />

              */}

               {
               <FormControlLabel control={<Switch checked={account.manage_tags} onChange={(event) => {const temp_stores = [...active_stores]; temp_stores[index].manage_tags = event.target.checked; set_active_stores(temp_stores);}}/>} 
                sx={{
                '& .MuiFormControlLabel-label': {
                fontSize: '15px',
                },
                }}
                label="Manage Tags"
                labelPlacement="start" />
              }

            </Stack>


            </Grid>


            <Grid
              item
              xs={6}
            >

                <LocalizationProvider LocalizationProvider dateAdapter={AdapterDateFns}>
                <TimePicker
                  label="Schedule"
                  value={active_stores[index].schedule != null ? active_stores[index].schedule : null}
                  onChange={(newValue) => {

                    console.log('value was: ', newValue)

                    const temp_stores = [...active_stores];

                    temp_stores[index].schedule = newValue;

                    set_active_stores(temp_stores);

                  }}
                  renderInput={(params) => <TextField size="small" {...params} fullWidth/>}
                />
              </LocalizationProvider>

            </Grid>



            <Grid item xs={6}>

              <div style={{position:'relative', zIndex:1000 - index, marginTop:1}}>
          
              <TimezoneSelect
                value={account.time_zone != null ? account.time_zone : ''}
                onChange={(value) => {console.log('value was: ', value); const temp_stores = [...active_stores]; temp_stores[index].time_zone = value; set_active_stores(temp_stores);}}
              />

              </div>
     
            </Grid>


          
          </Grid>

          </Grid>

          )
            
          })}

        </Grid>

        </Paper>
    
        </Grid>

      </Grid>

    </Container>      


    </Box>

     }

    </> 


  );


  function get_configurations_settings() {
    
    console.log('store_access_token')

    setIsLoading(true)

    getAccessJwtToken().then((auth_creds) => {

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/shopify/last_chance/configurations',{
          crossDomain:true,
          method: 'GET',
          headers: {
            'Authorization': auth_creds.jwt
          }})
          .then(res => res.json())
          .then(
            (result) => {
              
              setIsLoading(false)
  
              console.log('result was: ', cloneDeep(result))

              if(result.data) {

                var stores = result.data.configurations.stores

                // State should be controlled

                stores.forEach((store) => {

                  store.threshold = ''
                  store.schedule = ''
                  store.time_zone = ''
                  store.archive_no_stock = false
                  store.unarchive_in_stock = false
                  store.add_tag = false
                  store.remove_tag = false
                  store.manage_tags = false
                  store.inventory_tag = ''

                })

                const active_stores = result.data.configurations.active_stores;

                set_all_stores(stores);

                const temp_active_stores = []

                if(active_stores && active_stores.length > 0) {

                for (var z = 0; z < stores.length; z++) {

                  for (var z1 = 0; z1 < active_stores.length; z1++) {

                    if(active_stores[z1].store.toString() === stores[z].store.toString()) {

                      const temp_account = active_stores[z1]
                      
                      temp_account.name = stores[z].name

                      if(temp_account.threshold == null) {
                        temp_account.threshold = ''
                      }

                      if(temp_account.schedule != null) {
  
                        const start_date = new Date();
  
                        start_date.setHours(parseInt(temp_account.schedule.split(":")[0]))
  
                        start_date.setMinutes(parseInt(temp_account.schedule.split(":")[1]))
  
                        start_date.setSeconds(0)
  
                        temp_account.schedule = start_date
  
                        console.log('schedule was: ', start_date)
  
                      }
                      
                      temp_active_stores.push(temp_account)

                      break;

                    }

                  }

                }

                set_active_stores(temp_active_stores)

              }
              
            }else if(result.errorMessage){

              cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
              
            } else{
              cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
              console.log('Error', result)
            }
  
            },
        
            (error) => {
              setIsLoading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
              console.log('error was',error)
            }
      )

    })

  }



 

  function update_configurations(type) {

    console.log('updating')

    var request_body = {}

    if(type === "configurations"){

    request_body.configurations = {}

    request_body.request_type = "Update"

    console.log("active stores were: ", active_stores)

    var temp_stores = cloneDeep(active_stores)

    var start_date;

    var found_error = false;

    for (var i=0; i < temp_stores.length; i++) {

      start_date = temp_stores[i].schedule

      console.log('start date was: ', start_date)


      if(temp_stores[i].threshold == null || temp_stores[i].threshold.toString().trim().length === 0) {

        found_error = true;
        break

      }


      if(temp_stores[i].inventory_tag == null || temp_stores[i].inventory_tag.toString().trim().length === 0) {

        found_error = true;
        break

      }


      if(start_date) {

        if(isNaN(start_date.getHours()) || isNaN(start_date.getMinutes())) {

          found_error = true
          break

        } else {

          start_date = start_date.getHours().toString() + ":" + start_date.getMinutes().toString()
          temp_stores[i].schedule = start_date;

        }

      }
      else{

        found_error = true

      }

      if(temp_stores[i].time_zone ==  null) {

        found_error = true

      }

      }


      if(found_error){
        cmsContext.setSnackBarOpen(true, "error", "Please enter valid values for all fields!")
        return
      }

      request_body.configurations.active_stores = temp_stores

    }


    console.log('request body: ', request_body)
    
    setIsLoading(true)

    getAccessJwtToken().then((auth_creds) => {

      console.log("auth creds were: ", auth_creds)
      
      if(!has_product_management_write_access(auth_creds.current_user)){
        cmsContext.setSnackBarOpen(true, "error", "You do not have permission to perform this action!")
        setIsLoading(false)
        return
      }

      fetch('https://fri7xzt2n6.execute-api.eu-west-2.amazonaws.com/SnagCMS/shopify/last_chance/configurations', {
          crossDomain:true,
          method: 'POST',
          headers: {
            'content-type':'application/json',
            'Authorization': auth_creds.jwt
          },
          body: JSON.stringify(request_body)
        })
          .then(res => res.json())
          .then(
            (result) => {
  
              setIsLoading(false)
  
              console.log('result was: ', result)

              if(result.message) {

                if(type === "configurations") {

                  console.log('yes type configurations')

                  cmsContext.setSnackBarOpen(true, "success", result.message)

                  get_configurations_settings()

                }
              
              }else if(result.errorMessage){

                cmsContext.setSnackBarOpen(true, "error", result.errorMessage)
                
              }else{

                cmsContext.setSnackBarOpen(true, "error", "Error fetching data, please reload page")
                console.log('Error', result)

              }
  
            },
        
            (error) => {
              setIsLoading(false)
              cmsContext.setSnackBarOpen(true, "error", "Error completing request, please try again")
              console.log('error was',error)
            }
      )

    })


  }


};


export default LastChanceConfigs;